import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';
class AccountAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Auth';
	controllerName = 'accounts';

	/**
	 * Lấy token làm việc
	 * Tham số gồm sid, tenant_id/database_id (tùy tình huống có gì truyền đó)
	 */
	getToken(databaseId) {
		let request = {
			url: [this.getAPIUrl(), '/token/', databaseId].join(''),
		};
		return httpClient.getAsync(request);
	}

	/**
	 * Lấy dữ liệu cho popup chọn dữ liệu làm việc
	 */
	getTenants(param) {
		let request = {
			url: [this.getAPIUrl(), '/tenants'].join(''),
			params: param,
			withCredentials: true
		};

		return httpClient.getAsync(request);
	}

	/**
	 * Đăng xuất
	 */
	logout() {
		let request = {
			url: [this.getAPIUrl(), '/logout'].join(''),
		};

		return httpClient.getAsync(request);
	}

	/**
	 * Lấy link đăng nhập của MISAID
	 */
	loginWithLink(param) {
		let request = {
			url: [this.getAPIUrl(), '/LoginWithLink'].join(''),
			data: param,
		};

		return httpClient.postAsync(request);
	}

	/**
	 * Lấy link để nhúng vào iframe form bật 2FA
	 * DTQUOC: 23.07.2025
	 */
	generatelinklogin(param) {
		let request = {
			url: [this.getAPIUrl(), '/Generatelinklogin'].join(''),
			data: param,
		};

		return httpClient.postAsync(request);
	}

	// /**
	//  * Lấy thông tin phân quyền theo chi nhánh
	//  * Nếu không truyền thì sẽ đùng chi nhánh trong context
	//  */
	// getPermission(orgId) {
	// 	var url = [this.getAPIUrl(), 'permission'];
	// 	if (orgId) {
	// 		url.push(orgId);
	// 	}
	// 	let request = {
	//         url: url.join('/'),
	// 	};

	// 	return httpClient.getAsync(request);
	// }

	/**
	 * Đăng xuất khỏi ứng dụng
	 */
	logoff() {
		let request = {
			url: [this.getAPIUrl(), 'logoff'].join('/'),
		};

		return httpClient.getAsync(request);
	}

	/**
	 * Đăng nhập
	 */
	loginCode(model) {
		let request = {
			url: [this.getAPIUrl(), 'login-code'].join('/'),
			data: model
		};

		return httpClient.postAsync(request);
	}

	/**
	 * Xác thực 2 yếu tố
	 */
	verifyTwoFactor(model) {
		let request = {
			url: [this.getAPIUrl(), 'two-factor'].join('/'),
			data: model
		};
		return httpClient.postAsync(request);
	}
	/**
	 * Lấy phương thức xác thực hợp lệ 
	 * @param {*} username: Sdt hoặc email
	 * @returns 
	 */
	getAnotherWay(username) {
		let request = {
			url: [this.getAPIUrl(), 'another-way'].join('/'),
			data: username
		};
		return httpClient.postAsync(request);
	}
	/**
	 * Gửi lại mã xác thực
	 * @param {*} username: Sdt hoặc email
	 * @returns 
	 */
	resendCode(username) {
		let request = {
			url: [this.getAPIUrl(), 'resend-code'].join('/'),
			data: username
		};
		return httpClient.postAsync(request);
	}
	/**
	 * Đăng nhập dùng code
	 */
	async doLogin(param) {
		let request = {
			url: [this.getAPIUrl(), 'login'].join('/'),
			data: param
		};
		return await httpClient.postAsync(request);
	}

	/**
	 * Lấy context theo sid khi đăng nhập vào từ amis
	 */
	getContext(param) {
		let queryString = qs.stringify(param);
		let request = {
			url: [this.getAPIUrl(), '/context?', queryString].join(''),
		};

		return httpClient.getAsync(request);
	}

	/**
	 * Chuyển đơn vị
	 * @param {} userID 
	 * @returns 
	 */
	 async switchOrganization(tenantUser) {
	  let request = {
		  url: [this.getAPIUrl(), 'switch-organization'].join('/'),
		  data: tenantUser
	  };
	  let res = await httpClient.postAsync(request);
	  return res
	  }

	  async getTenantUserByUserName(userName) {
	  	let request = {
	    	url: this.getAPIUrl() + `/TenantUser/${userName}`
	  	}
	    return httpClient.getAsync(request)
	}
}

export default new AccountAPI();
